// // // // import axios from 'axios';
// // // // import {
// // // //   Box,
// // // //   Button,
// // // //   Flex,
// // // //   Icon,
// // // //   Text,
// // // //   useColorModeValue,
// // // // } from "@chakra-ui/react";
// // // // import Card from "components/card/Card.js";
// // // // // Custom components
// // // // import LineChart from "components/charts/BarChart";
// // // // import React, { useState, useEffect } from "react";
// // // // import { MdBarChart } from "react-icons/md";
// // // // import ReactApexChart from "react-apexcharts";
// // // // // import {
// // // // //   barChartDataConsumption,
// // // // //   barChartOptionsConsumption,
// // // // // } from "variables/charts";

// // // // function obterAnoAtual() {
// // // //   const dataAtual = new Date();
// // // //   const anoAtual = dataAtual.getFullYear();
// // // //   return anoAtual;
// // // // }



// // // // export default function Empresas({ data, anos }) {
// // // //   // const { ...rest } = props;
// // // //   const [barChart, setbarChart] = useState([]);
// // // //   const [ano, setAno] = useState('');



// // // //   useEffect(() => {
// // // //     setbarChart(data);
// // // //     setAno(anos);
// // // //     // (async () => {
// // // //     //   const { data } = await axios.get('http://localhost:4000/anual');
// // // //     //   setbarChart(data);
// // // //     // })();
// // // //   }, [data]);

// // // //   const mesesAno = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
// // // //   const series = {};
// // // //   let valorTotalGeral = 0;

// // // //   for (let i = 0; i < barChart.length; i++) {
// // // //     const dado = barChart[i];
// // // //     const name = dado.Status;

// // // //     // Cria uma série se ainda não existe para o status atual
// // // //     if (!series[name]) {
// // // //       series[name] = {
// // // //         name: name,
// // // //         data: [],
// // // //       };
// // // //     }

// // // //     // Adiciona um ponto à série com as informações do dado atual
// // // //     const novoPonto = {
// // // //       x: dado.Mes,
// // // //       y: dado.Total
// // // //       // valorTotalFormatado: dado.valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) 
// // // //     };

// // // //     // console.log(novoPonto)
// // // //     valorTotalGeral += dado.Total;

// // // //     series[name].data.push(novoPonto);

// // // //     // Ordena os pontos da série em ordem crescente com base no valor de x
// // // //     series[name].data.sort((a, b) => a.x - b.x);
// // // //   }

// // // //   for (const serie of Object.values(series)) {
// // // //     const dataMonths = serie.data.map(ponto => ponto.x);
// // // //     for (const month of mesesAno) {
// // // //       if (!dataMonths.includes(month)) {
// // // //         serie.data.push({ x: month, y: 0 });
// // // //       }
// // // //     }
// // // //   }

// // // //   const seriesArray = Object.values(series);
// // // //   // console.log(seriesArray)

// // // //   const mesesNaOrdemDesejada = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

// // // //   // Mapeamento de meses para garantir a ordem correta
// // // //   const mapaMeses = {};
// // // //   mesesNaOrdemDesejada.forEach((mes, index) => {
// // // //     mapaMeses[mes] = index;
// // // //   });

// // // //   // Função para reorganizar os dados no seriesArray
// // // //   const reorganizarSeriesArray = (seriesArray, mesesMap) => {
// // // //     return seriesArray.map(series => ({
// // // //       ...series,
// // // //       data: series.data.sort((a, b) => mesesMap[a.x] - mesesMap[b.x])
// // // //     }));
// // // //   };

// // // //   // Aplicar a reorganização
// // // //   const seriesArrayReorganizado = reorganizarSeriesArray(seriesArray, mapaMeses);

// // // //   // console.log(seriesArrayReorganizado);
// // // //   const title = ano + " - Valor Total do Período - R$" + valorTotalGeral.toLocaleString('pt-BR', { minimumFractionDigits: 2 });



// // // //   const options = {
// // // //     chart: {
// // // //       type: 'bar',
// // // //       height: 500,
// // // //       stacked: true,
// // // //       toolbar: {
// // // //         show: false
// // // //       },
// // // //       zoom: {
// // // //         enabled: false
// // // //       }
// // // //     },
// // // //     title: {
// // // //       text: title,
// // // //       align: 'center',
// // // //       margin: 10,
// // // //       offsetX: 0,
// // // //       offsetY: 0,
// // // //       floating: false,
// // // //       style: {
// // // //         fontSize: '18px',
// // // //         fontWeight: 'bold',
// // // //         fontFamily: undefined,
// // // //         color: 'white'
// // // //       },
// // // //     },
// // // //     plotOptions: {
// // // //       bar: {
// // // //         barHeight: '80%', // ajuste o valor de barHeight para controlar a altura das barras
// // // //         barWidth: '50%',
// // // //       },
// // // //     },
// // // //     tooltip: {
// // // //       theme: "dark",
// // // //       enabled: true,
// // // //       style: {
// // // //         fontSize: '14px', // Ajuste o tamanho da fonte conforme necessário
// // // //         background: '#2c3e50', // Cor de fundo desejada
// // // //         color: '#ffffff', // Cor do texto desejada
// // // //       },
// // // //       onDatasetHover: {
// // // //         highlightDataSeries: true,
// // // //       },
// // // //     },
// // // //     dataLabels: {
// // // //       enabled: false
// // // //     },
// // // //     stroke: {
// // // //       show: true,
// // // //       width: 2,
// // // //       colors: ['transparent']
// // // //     },
// // // //     xaxis: {
// // // //       // categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
// // // //       categories: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
// // // //       labels: {
// // // //         formatter: function (val) {
// // // //           // Mapeie o valor completo para o valor abreviado
// // // //           const mesAbreviado = {
// // // //             'Janeiro': 'Jan',
// // // //             'Fevereiro': 'Fev',
// // // //             'Março': 'Mar',
// // // //             'Abril': 'Abr',
// // // //             'Maio': 'Mai',
// // // //             'Junho': 'Jun',
// // // //             'Julho': 'Jul',
// // // //             'Agosto': 'Ago',
// // // //             'Setembro': 'Set',
// // // //             'Outubro': 'Out',
// // // //             'Novembro': 'Nov',
// // // //             'Dezembro': 'Dez'
// // // //           };

// // // //           // Use o mapeamento para obter o valor abreviado
// // // //           return mesAbreviado[val];
// // // //         },
// // // //         style: {
// // // //           colors: "white",
// // // //         }
// // // //       }
// // // //     },
// // // //     yaxis: {
// // // //       show: true,
// // // //       labels: {
// // // //         formatter: function (value) {
// // // //           return 'R$ ' + value.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
// // // //         },
// // // //         style: {
// // // //           colors: "white",
// // // //         }
// // // //       },
// // // //     },
// // // //     fill: {
// // // //       opacity: 1
// // // //     },
// // // //     responsive: [
// // // //       {
// // // //         breakpoint: 768, // Define o ponto de quebra para telas menores
// // // //         options: {
// // // //           title: {
// // // //             style: {
// // // //               fontSize: '14px' // Tamanho do título para telas menores
// // // //             }
// // // //           }
// // // //         }
// // // //       }
// // // //       // Você pode adicionar mais breakpoints e opções conforme necessário
// // // //     ]
// // // //   };

// // // //   return (
// // // //     <Card bg="#0B0B61" color="white" borderRadius={0} align='center' direction='column' w='100%'>
// // // //       <Flex align='center' w='100%' px='15px' py='10px'>
// // // //         <Text
// // // //           me='auto'
// // // //           // color={textColor}
// // // //           fontSize='xl'
// // // //           fontWeight='700'
// // // //           lineHeight='100%'>
// // // //           Evolução de vendas mensal 
// // // //         </Text>
// // // //       </Flex>
// // // //       {/* <Flex align='center' w='100%' px='15px'>
// // // //         <Text
// // // //           me='auto'
// // // //           color="white"
// // // //           fontSize='sm'  // Tamanho menor
// // // //           lineHeight='100%'>
// // // //           {title}
// // // //         </Text>
// // // //       </Flex> */}
// // // //       <Box h='300px' mt='auto'>
// // // //         {/* <LineChart
// // // //             chartData={bar}
// // // //             chartOptions={lineChartOptionsTotalSpent}
// // // //           /> */}
// // // //         <ReactApexChart
// // // //           options={options}
// // // //           series={seriesArrayReorganizado}
// // // //           type='bar'
// // // //           width='100%'
// // // //           height='100%'
// // // //         />
// // // //       </Box>
// // // //     </Card>
// // // //   )
// // // // }

// // // import React, { useState, useEffect } from "react";
// // // import { Box, Flex, Text } from "@chakra-ui/react";
// // // import Card from "components/card/Card.js";
// // // import ReactApexChart from "react-apexcharts";

// // // export default function EmpresasPolarArea({ data, anos }) {
// // //   const [ano, setAno] = useState('');
// // //   const [series, setSeries] = useState([]);
// // //   const [labels, setLabels] = useState([]);

// // //   useEffect(() => {
// // //     setAno(anos);

// // //     // Agrupamento por status
// // //     const totalPorStatus = {};
// // //     let totalGeral = 0;

// // //     for (const item of data) {
// // //       if (!totalPorStatus[item.Status]) {
// // //         totalPorStatus[item.Status] = 0;
// // //       }
// // //       totalPorStatus[item.Status] += item.Total;
// // //       totalGeral += item.Total;
// // //     }

// // //     const seriesData = Object.values(totalPorStatus);
// // //     const labelsData = Object.keys(totalPorStatus);

// // //     setSeries(seriesData);
// // //     setLabels(labelsData);
// // //   }, [data, anos]);

// // //   const options = {
// // //     chart: {
// // //       type: 'polarArea'
// // //     },
// // //     labels: labels,
// // //     title: {
// // //       text: ano + " - Total por Status - R$ " + series.reduce((acc, val) => acc + val, 0).toLocaleString('pt-BR', {
// // //         minimumFractionDigits: 2
// // //       }),
// // //       align: 'center',
// // //       style: {
// // //         fontSize: '16px',
// // //         color: 'white'
// // //       }
// // //     },
// // //     stroke: {
// // //       colors: ['#fff']
// // //     },
// // //     fill: {
// // //       opacity: 0.9
// // //     },
// // //     legend: {
// // //       position: 'bottom',
// // //       labels: {
// // //         colors: 'white'
// // //       }
// // //     },
// // //     theme: {
// // //       mode: 'dark'
// // //     },
// // //     tooltip: {
// // //       y: {
// // //         formatter: (value) =>
// // //           'R$ ' + value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
// // //       }
// // //     },
// // //     responsive: [
// // //       {
// // //         breakpoint: 768,
// // //         options: {
// // //           chart: {
// // //             width: '100%'
// // //           },
// // //           legend: {
// // //             position: 'bottom'
// // //           }
// // //         }
// // //       }
// // //     ]
// // //   };

// // //   return (
// // //     <Card bg="#0B0B61" color="white" borderRadius={0} align='center' direction='column' w='100%'>
// // //       <Flex align='center' w='100%' px='15px' py='10px'>
// // //         <Text me='auto' fontSize='xl' fontWeight='700' lineHeight='100%'>
// // //           Distribuição de Vendas por Status
// // //         </Text>
// // //       </Flex>
// // //       <Box h='350px' w="100%">
// // //         <ReactApexChart
// // //           options={options}
// // //           series={series}
// // //           type='polarArea'
// // //           height='100%'
// // //         />
// // //       </Box>
// // //     </Card>
// // //   );
// // // }
// // import React, { useEffect, useState } from "react";
// // import { Box, Flex, Text } from "@chakra-ui/react";
// // import Card from "components/card/Card";
// // import ReactApexChart from "react-apexcharts";

// // export default function GraficoPolarArea({ data, anos }) {
// //   const [meses, setMeses] = useState([]);
// //   const [valores, setValores] = useState([]);
// //   const [ano, setAno] = useState("");

// //   useEffect(() => {
// //     setAno(anos);

// //     // Inicializa um mapa para acumular os totais por mês
// //     const mapaMeses = {};

// //     data.forEach(item => {
// //       const mes = item.Mes;
// //       const total = item.Total;

// //       if (!mapaMeses[mes]) {
// //         mapaMeses[mes] = 0;
// //       }

// //       mapaMeses[mes] += total;
// //     });

// //     // Ordena os meses na ordem correta
// //     const ordemMeses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
// //       'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

// //     const mesesOrdenados = ordemMeses.filter(mes => mapaMeses.hasOwnProperty(mes));
// //     const totaisOrdenados = mesesOrdenados.map(mes => mapaMeses[mes]);

// //     setMeses(mesesOrdenados);
// //     setValores(totaisOrdenados);
// //   }, [data, anos]);

// //   const title = `${ano} - Total por Mês`;

// //   const options = {
// //     chart: {
// //       type: 'polarArea'
// //     },
// //     labels: meses,
// //     title: {
// //       text: title,
// //       style: {
// //         color: 'white'
// //       }
// //     },
// //     fill: {
// //       opacity: 0.8
// //     },
// //     stroke: {
// //       colors: ['#fff']
// //     },
// //     yaxis: {
// //       labels: {
// //         formatter: function (val) {
// //           return "R$ " + val.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
// //         },
// //         style: {
// //           colors: 'white'
// //         }
// //       }
// //     },
// //     legend: {
// //       labels: {
// //         colors: 'white'
// //       }
// //     },
// //     responsive: [
// //       {
// //         breakpoint: 768,
// //         options: {
// //           chart: {
// //             height: 300
// //           },
// //           legend: {
// //             position: 'bottom'
// //           }
// //         }
// //       }
// //     ]
// //   };

// //   return (
// //     <Card bg="#0B0B61" color="white" borderRadius={0} align="center" direction="column" w="100%">
// //       <Flex align="center" w="100%" px="15px" py="10px">
// //         <Text fontSize="xl" fontWeight="700">Distribuição Total de Vendas por Mês</Text>
// //       </Flex>
// //       <Box w="100%" h="400px">
// //         <ReactApexChart options={options} series={valores} type="polarArea" width="100%" height="100%" />
// //       </Box>
// //     </Card>
// //   );
// // }

// import React, { useEffect, useState } from "react";
// import { Box, Flex, Text } from "@chakra-ui/react";
// import Card from "components/card/Card";
// import ReactApexChart from "react-apexcharts";
// import api from '../../../../contexts/api';

// export default function GraficoPolarArea({ data, anos }) {
//   const [meses, setMeses] = useState([]);
//   const [valores, setValores] = useState([]);
//   const [ano, setAno] = useState("");

//   useEffect(() => {
//     setAno(anos);

//     const mapaMeses = {};
//     data.forEach(item => {
//       const mes = item.Mes;
//       const total = item.Total;
//       if (!mapaMeses[mes]) {
//         mapaMeses[mes] = 0;
//       }
//       mapaMeses[mes] += total;
//     });

//     const ordemMeses = [
//       "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
//       "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
//     ];

//     const mesesOrdenados = ordemMeses.filter(mes => mapaMeses.hasOwnProperty(mes));
//     const totaisOrdenados = mesesOrdenados.map(mes => mapaMeses[mes]);

//     setMeses(mesesOrdenados);
//     setValores(totaisOrdenados);
//   }, [data, anos]);

//   const title = `${ano} - Total por Mês`;

//   const options = {
//     chart: {
//       type: "polarArea",
//       toolbar: { show: false }
//     },
//     labels: meses,
//     title: {
//       text: title,
//       style: { color: "white" }
//     },
//     fill: {
//       opacity: 0.85
//     },
//     stroke: {
//       colors: ["#fff"]
//     },
//     yaxis: {
//       show: false // 🔴 Oculta os valores numéricos no centro
//     },
//     dataLabels: {
//       enabled: false // 🔴 Desativa os rótulos diretos no gráfico
//     },
//     tooltip: {
//       y: {
//         formatter: function (val) {
//           return "R$ " + val.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
//         }
//       }
//     },
//     legend: {
//       show: false // 🔴 Oculta legenda fixa (deixa apenas no hover via tooltip)
//     },
//     responsive: [
//       {
//         breakpoint: 768,
//         options: {
//           chart: { height: 300 }
//         }
//       }
//     ]
//   };

//   return (
//     <Card
//       bg="#0B0B61"
//       color="white"
//       borderRadius={0}
//       align="center"
//       direction="column"
//       w="100%"
//     >
//       <Flex align="center" w="100%" px="15px" py="10px">
//         <Text fontSize="xl" fontWeight="700">
//           Distribuição Total de Vendas por Mês
//         </Text>
//       </Flex>
//       <Box w="100%" h="400px">
//         <ReactApexChart
//           options={options}
//           series={valores}
//           type="polarArea"
//           width="100%"
//           height="100%"
//         />
//       </Box>
//     </Card>
//   );
// }
import React, { useEffect, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import Card from "components/card/Card";
import ReactApexChart from "react-apexcharts";
import api from "../../../../contexts/api";
import AsyncStorage from "@react-native-async-storage/async-storage";

export default function GraficoPolarEmpresas({ filtros }) {
  const [empresas, setEmpresas] = useState([]);
  const [valores, setValores] = useState([]);

  const getData = async () => {
    try {
      const param = [];
      const value = await AsyncStorage.getItem("@storage_Key");
      param.push(value);
      const perf = await AsyncStorage.getItem("@perfil");
      param.push(perf);
      const vende = await AsyncStorage.getItem("@vendedor");
      param.push(vende);
      const vend = await AsyncStorage.getItem("@name");
      param.push(vend);
      if (param !== null) return param;
    } catch (e) {
      alert("Erro ao buscar dados do usuário");
    }
  };

  useEffect(() => {
  const fetchEmpresas = async () => {
    try {
      const key = await getData(); // pega o user, perfil, etc
      if (!key) return;

      // Monta o objeto params combinando user + filtros
      const params = {
        user: key[0],  // ou key que desejar
        ...filtros,    // espalha os filtros passados como props ou estado
      };

      const { data } = await api.get("/vendasEmpresas", { params });

      const mapaEmpresas = {};
      data.forEach((item) => {
        const empresa = item.Empresa || "Indefinida";
        const total = item.Total || 0;
        if (!mapaEmpresas[empresa]) mapaEmpresas[empresa] = 0;
        mapaEmpresas[empresa] += total;
      });

      const nomesEmpresas = Object.keys(mapaEmpresas);
      const totais = nomesEmpresas.map((emp) => mapaEmpresas[emp]);

      setEmpresas(nomesEmpresas);
      setValores(totais);
    } catch (error) {
      console.error("Erro ao buscar empresas:", error);
    }
  };

  fetchEmpresas();
}, [filtros]);

  const options = {
    chart: { type: "polarArea", toolbar: { show: false } },
    labels: empresas,
    // title: {
    //   // text: "Total de Vendas por Empresa",
    //   // style: { color: "white" }
    // },
    fill: { opacity: 0.85 },
    stroke: { colors: ["#fff"] },
    yaxis: { show: false },
    dataLabels: { enabled: false },
    tooltip: {
      y: {
        formatter: (val) =>
          "R$ " + val.toLocaleString("pt-BR", { minimumFractionDigits: 2 })
      }
    },
    legend: {
      show: true,
      position: "right",
      labels: { colors: "#fff" }
    },
    responsive: [
      {
        breakpoint: 768,
        options: { chart: { height: 300 } }
      }
    ]
  };

  return (
    <Card bg="#0B0B61" color="white" borderRadius={0} align="center" direction="column" w="100%">
      <Flex align="center" w="100%" px="15px" py="10px">
        <Text fontSize="xl" fontWeight="700">
          Distribuição por Empresa
        </Text>
      </Flex>
      <Box w="100%" h="400px">
        <ReactApexChart
          options={options}
          series={valores}
          type="polarArea"
          width="100%"
          height="100%"
        />
      </Box>
    </Card>
  );
}
